import { Link } from 'react-router-dom';
import { useNewsList } from '../../misc/lib/news';
import routes from '../../misc/routes';
import NewsCardSidebar from './NewsCardSidebar';
import './NewsList.scss';

const NewsListSidebar = () => {
  const news = useNewsList(5);

  return (
    <div className="app-news-list-sidebar">
      { news.map((n, i) => (
        <Link key={ i } to={ routes.news.children.specificNews.path.replace(':id', n.id) }>
          <NewsCardSidebar { ...n } />
        </Link>
      )) }
    </div>
  );
};

export default NewsListSidebar;
